module.exports = __webpack_public_path__ + "img/bonus-arrow.e71b9937.svg";